export default "__VITE_ASSET__BzEmtScy__"